import { ApiResponse } from '../common';

export enum OrderBy {
  Asc = 'asc',
  Desc = 'desc',
}

export type IdpType = string;

/*
export enum IdpType {
  OktaB2E = 'OKTA-B2E',
  OktaGDC = 'OKTA-GDC', // B2B
  OktaLSS = 'OKTA-LSS',
  OktaEwacs = 'OKTA-EWACS',
  OktaBRB = 'OKTA-BRB', // brazil
  OktaOrigin = 'OKTA-ORIGIN',
}
*/

export type Pagination = {
  q: string;
  sort: string;
  order: OrderBy;
  offset: number;
  limit: number;
};

export type AuditFields = {
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;
};
// Team Members
export type TeamMemberParam = { id: string };
export type TeamMember = {
  id: string;
  fName: string;
  lName: string;
  dName: string;
  email: string;
  idpType: IdpType;
  companyId: string;
  client: string;
  roles: string;
  [key: string]: string;
} & Pick<AuditFields, 'updatedAt'>;
export type TeamMembersResult = {
  users: TeamMember[];
  total: number;
} & Pagination;
export type TeamMembersResponse = ApiResponse<TeamMembersResult>;
export type TeamMemberResponse = ApiResponse<TeamMember>;

// Permissions - GET ALL
export type PlainPermision = { id: string; name: string };
export type Permission = PlainPermision & AuditFields;
export type PermissionsResult = {
  permissions: Permission[];
  total: number;
} & Pagination;
export type PermissionsResponse = ApiResponse<PermissionsResult>;

// Application Roles - GET ALL
export type PlainRole = { id: string; name: string };
export type Role = PlainRole & AuditFields;
export type RolesResult = { roles: Role[]; total: number } & Pagination;
export type RolesResponse = ApiResponse<RolesResult>;

// Application Role To Permissions - GET ALL
export type RoleToPermissions = Role & {
  permissions: PlainPermision[];
  client: string;
};
export type RoleToPermissionsResult = {
  mappings: RoleToPermissions[];
  total: number;
} & Pagination;
export type RoleToPermissionsResponse = ApiResponse<RoleToPermissionsResult>;
// Application Role To Permissions - UPDATE
export type MapRolesAndPermission = {
  roleId: string;
  client: string;
  permissionIds: string[];
};
export type MapRolesAndPermissions = MapRolesAndPermission[];
export type MapRolesAndPermissionsResponse = ApiResponse<null>;

// IDP Role To Application Roles - GET ALL
export type PlainIDPRole = { id: string; idpType: IdpType; name: string };
export type IdpRole = PlainIDPRole & AuditFields;
export type IdpRoleAndRoles = {
  roles: PlainRole[];
} & IdpRole;
export type IdpRoleAndRolesResult = {
  mappings: IdpRoleAndRoles[];
  total: number;
} & Pagination;
export type IdpRoleAndRolesResponse = ApiResponse<IdpRoleAndRolesResult>;
// IDP Role To Application Roles - UPDATE
export type UpdateMapIdpRoleAndRoles = {
  id?: string;
  idpType: IdpType;
  name: string;
  roleIds: string[];
};
export type GeneralConfig = {
  showOnlyInternalPlatformType: boolean;
  showOnlyEcsActivatePurposeType: boolean;
  showOnlyRealtimeExecutionMode: boolean;
  showBothExecutionModes: boolean;
  showOnlyRealtimeExecutionModeTest: boolean;
  canShowUserPermissions: boolean;
  canShowSandboxTableName: boolean;
  canHaveDataCurationZone: boolean;
  canHaveFileService: boolean;
  canShowFeedbackForm: boolean;
  canHaveOktaORIGIN: boolean;
  canShowContactUsFileUpload: boolean;
  canSupportCustomLibs: boolean;
  canShowClientName: boolean;
};
export type BrandingConfig = {
  appTitle: string;
  appDescription?: string;
};

export type MarketingConfig = {
  canSelectDeployToMarketing: boolean;
};
export type RunsConfig = {
  canRunUAT: boolean;
  canRunDevTesting: boolean;
  canRunProd: boolean;
  canRunProdCampaigns: boolean;
  canRunSnapshot: boolean;
};

export type MonitoringConfig = {
  canAccessModelAnalysis: boolean;
  canAccessDriftReport: boolean;
  canAccessPerformanceDashboard: boolean;
};

export type OpsAppFeatureConfig = {
  marketing: MarketingConfig;
  runs: RunsConfig;
  branding: BrandingConfig;
  general: GeneralConfig;
  monitoring: MonitoringConfig;
};
// export type OpsAppFeatureConfig = {
//   id: string;
//   feature: string;
//   client: string;
//   config: RunsConfig | MarketingConfig | BrandingConfig | GeneralConfig;
// };
export type MapIdpRoleAndRoles = UpdateMapIdpRoleAndRoles[];
export type MapIdpRoleAndRolesResponse = ApiResponse<null>;
// IDP Role To Application Roles - DELETE
export type IdpRoleAndRolesParam = { id: string };
export type DeleteIdpRoleAndRolesMapResponse = ApiResponse<null>;

export type OpsAppFeatureConfigResponse = ApiResponse<OpsAppFeatureConfig>;

export type DeletePartyIdpIdentifierLookupMapResponse = ApiResponse<null>;
